import { Badge } from "@dune/ui";
import { formatPricing, formatSimpleDate } from "@dune/utils";
import {
	ReceiptPaymentSchema,
	receiptPaymentTypeLabels,
	Role,
} from "@dune/vars";
import { ColumnDef } from "@tanstack/react-table";
import { match } from "ts-pattern";
import DeletePaymentReceiptModal from "../modals/DeletePaymentReceiptModal";
import UpdatePaymentReceiptModal from "../modals/UpdatePaymentReceiptModal";

interface ReceiptPaymentColumnsProps {
	receiptId: number;
	me: { role: Role | null } | undefined;
}

export const getReceiptPaymentColumns = ({
	receiptId,
	me,
}: ReceiptPaymentColumnsProps): ColumnDef<ReceiptPaymentSchema>[] => [
	{
		accessorKey: "paymentReference",
		header: "Référence",
		cell: ({ row }) => {
			const value = row.getValue<string>("paymentReference");
			return <div className="text-sm">{value}</div>;
		},
	},
	{
		accessorKey: "type",
		header: "Mode de règlement",
		cell: ({ row }) => {
			const label = receiptPaymentTypeLabels[row.original.type];
			return <Badge variant="secondary">{label}</Badge>;
		},
	},
	{
		accessorKey: "paymentDate",
		header: "Date de règlement",
		cell: ({ row }) => (
			<div className="font-medium">
				{formatSimpleDate(row.getValue("paymentDate"))}
			</div>
		),
	},
	{
		accessorKey: "amount",
		header: "Montant",
		cell: ({ row }) => (
			<div className="text-sm font-medium text-green-600">
				{formatPricing(row.getValue("amount"))}
			</div>
		),
	},
	{
		id: "actions",
		header: "",
		cell: ({ row }) =>
			match(me)
				.with({ role: "DUNE" }, () => (
					<div
						className="flex gap-1"
						onClick={(e) => e.stopPropagation()}
						onKeyDown={() => {}}
					>
						<UpdatePaymentReceiptModal
							payment={row.original}
							receiptId={receiptId}
						/>
						<DeletePaymentReceiptModal
							payment={row.original}
							receiptId={receiptId}
						/>
					</div>
				))
				.otherwise(() => undefined),
	},
];
